import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  dashboard: icon('ic-dashboard'),
  analytics: icon('ic-analytics'),
  file: icon('ic-file'),
};

// ----------------------------------------------------------------------

export const navData = (t: (key: string) => string): NavSectionProps['data'] => [
  {
    subheader: t('reviewer.reviewer'),
    items: [
      {
        title: t('reviewer.dashboard'),
        path: paths.dashboard.artham.reviewer.dashboard,
        icon: ICONS.dashboard,
        primary: true,
      },
      {
        title: t('reviewer.kyc'),
        path: paths.dashboard.artham.reviewer.kyc,
        icon: <Iconify icon="solar:user-id-bold-duotone" width={24} />,
        primary: true,
      },
      {
        title: t('reviewer.users'),
        path: paths.dashboard.artham.usersDirectory,
        icon: <Iconify icon="solar:users-group-two-rounded-bold-duotone" width={24} />,
      },
      {
        title: t('reviewer.grievances'),
        path: paths.dashboard.artham.reviewer.grievances,
        icon: <Iconify icon="solar:shield-warning-bold-duotone" width={24} />,
        primary: true,
      },
      {
        title: t('reviewer.notifications'),
        path: paths.dashboard.artham.reviewer.notifications,
        icon: <Iconify icon="solar:bell-bold-duotone" width={24} />,
        primary: true,
      },
      {
        title: t('reviewer.auditLog'),
        path: paths.dashboard.artham.reviewer.auditLog,
        icon: ICONS.analytics,
      },
    ],
  },
];
